module.exports = __webpack_public_path__ + "img/seloMedalhaPrataSombra.a54a256d.png";